import BaseApiRequest from "./BaseApiRequest";
import { GET_PROSPECT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetProspectRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = GET_PROSPECT_URL;

  constructor(request) {
    super();

    this.body = request;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
